// theme.js
import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    primary: {
      main: 'rgb(21, 47, 49)', // Subtidal primary color
    },
    secondary: {
      main: 'rgb(84, 205, 119)',
    },
    background: {
      default: '#f9fafb',
      paper: '#ffffff',
    },
  },
  main: {
    marginLeft: '30px'
  },
  typography: {
    // Keep your existing font family
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          borderRadius: 8,
          fontWeight: 500,
          marginLeft: '240px',
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 12,
          boxShadow: '0 2px 12px 0 rgba(0,0,0,0.05)',
        },
      },
    },
  },
});

export default theme;